import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getAttendeeDetailsById,  registraPaqueteConferencia  } from '../SelfRegistration/actions'
import { Stepper, Step, StepLabel } from "@material-ui/core";
import useWindowDimensions from '../hooks/useWindowDimensions';
import { makeStyles } from '@material-ui/styles';
import { Grid, TextField, Button, Typography } from '@material-ui/core';
import { motion } from "framer-motion/dist/framer-motion";
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(6)
  }
}));


const RegistroConferenciaPaquete = props => {


  const { width } = useWindowDimensions();
  const { className, ...rest } = props;
  const classes = useStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [isDisabled, setIsDisabled] = useState(false);
  const [attendee, setAttendee] = useState(null);
  const [celular, setCelular] = useState("");
  const [attendeeName, setAttendeeName] = useState("");
  const [tieneCelular, setTieneCelular] = useState(true);  
  const [attendeeMessage, setAttendeeMessage] = useState("Por favor, acerque el código QR al lector");
  //const [event, setEvent] = useState({});
  const [step, setStep] = useState(0);
  const [guid, setGuid] = useState("");
  //const [guidPre, setGuidPre] = useState("");
  //const [attendeeid, setAttendeeId] = useState("");
  const [categoria, setCategoria] = useState("");
  const [event, setEvent] = useState("");
  //const [externalId, setExternalId] = useState("");


  const messages = ["Acerca el código QR impreso en el gafete al lector",
    "Toma la etiqueta de la impresora y pegala en el gafete",
    "Listo!"
  ];

  const inputReference = useRef(null);

  const handleChange = async (event) => {
    let data = event.target.value;
    
    if (event.target.name === "guid")
      setGuid(data);

    /*
    console.log(data);
    console.log(step);
    console.log(data.length);
    */


    if (data) {
      if (step === 0 && data.length >= 24) {
        try {
          
          var attendeeId = data.substring(0, 24);

          console.log(attendeeId);

          let attendee = (await getAttendeeDetailsById(attendeeId)).data;

          if (!attendee) {
            setAttendeeMessage("El usuario no esta registrado en el evento 😔");
            return setTimeout(() => window.location.reload(false), 6000);
          }
          
          setAttendee(attendee);
          //setCelular(attendee.celular || "");

          const nombre = `${attendee.nombres} ${attendee.apellidos}`;
          setAttendeeName(nombre);
          setAttendeeMessage(`Bienvenido ${nombre} 👏`);


          setStep(1);
          //setTimeout(() => window.location.reload(false), 6000);
        }
        catch (error) {
          console.log(error);
          setAttendeeMessage("Error! no fue posible procesar la entrada 🛑");
          setTimeout(() => window.location.reload(false), 6000);
        }
      }
    }
  }


  const handleSave = async () => {
    try {
      setIsDisabled(true);
      const stationId = localStorage.getItem("station");
      const registro = await registraPaqueteConferencia(attendee._id, stationId);

      if (registro.status === 200) {
        enqueueSnackbar("Las paquete fue actualizado satisfactoriamente",  {variant: 'success'});
      } else {
        enqueueSnackbar("Algo salió mal. Por favor, inténtelo de nuevo más tarde",  {variant: 'error'});
      }
      setIsDisabled(false);
      
      setStep(2);
      setTimeout(() => window.location.reload(false), 6000);

    } catch (error) {
      console.error(error);
      setAttendeeMessage("Error! no fue posible procesar la entrada 🛑");
    } 
  };


  const handleError = err => {
    console.error(err)
  }


  useEffect(() => {
    inputReference.current.focus();
  }, [])

  const previewStyle = {
    width: (width < 768) ? '50%' : '30%'
  }


  return (
    <div className={classes.root}>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="stretch"
      >
        <Grid item xs={12}>
          <div align="center">
            <Typography variant="h1">
              Bienvenido! Por favor sigue las instrucciones mostradas en pantalla para realizar 
            </Typography>
            <br></br>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div align="center">
            <Stepper alternativeLabel activeStep={step}>
              <Step>
                <StepLabel>Acerca el código QR impreso en el gafete al lector</StepLabel>
              </Step>
              <Step>
                <StepLabel>Haz click en el boton Registrar paquete para continuar</StepLabel>
              </Step>
              <Step completed>
              <StepLabel>Listo, haz realizado el registro del paquete al invitado!</StepLabel>
              </Step>
            </Stepper>
            <br></br>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div align="center" >
                {step === 0 ?
                  <>              
                    <Grid item xs={12}>
                      <Typography variant="h3">
                        Paso {step + 1}. {messages[step]}
                      </Typography>
                      <br></br>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h1">
                        {attendeeMessage}
                      </Typography>
                      <br></br>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        autoFocus
                        label=""
                        margin="dense"
                        name="guid"
                        onChange={handleChange}
                        required
                        value={guid}
                        variant="outlined"
                        ref={inputReference}
                      />
                    </Grid>
                  </>
                  :
                  step === 1 ?
                  <>
                      <Grid item xs={4}>
                        <Button
                          id="buttonSave"
                          variant="contained"
                          color="primary"
                          fullWidth
                          size="large"
                          style={{ fontSize: "1.2rem", padding: "12px 0" }}
                          onClick={handleSave}
                          disabled={isDisabled}
                        >
                          Registrar paquete para {attendeeName}
                        </Button>
                      </Grid>
                  </>
                  : step === 2 ?
                  <>
                                  <motion.div
                  className="box"
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{
                    default: {
                      duration: 0.3,
                      ease: [0, 0.71, 0.2, 1.01]
                    },
                    scale: {
                      type: "spring",
                      damping: 5,
                      stiffness: 100,
                      restDelta: 0.001
                    }
                  }}
                >
                  <Grid item xs={12}>
                    <Typography variant="h1">
                      Felicidades {attendeeName}! el registro a las conferencias fue exitoso 👏
                    </Typography>
                  </Grid>
                </motion.div>
              </>
              :
              <>  </>
            }
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

RegistroConferenciaPaquete.prototype = {
  className: PropTypes.string
};

export default RegistroConferenciaPaquete;


